import { TrackingFrequency } from "@dimensional-engineering/dimensional-models";

import styles from "./TraitsAssessmentModal.module.css";

import Pattern from "@/components/traits/pattern/Pattern/Pattern";
import Element from "@/components/traits/element/Element/Element";
import TimeIcon from "@/components/assessments-new/root/icons/TimeIcon";
import { trackingFrequencyMap } from "../utils";
import ThemedButton from "@/components/shared/ThemedButton/ThemedButton";
import { PremiumTraitAccessDeniedBarTraitAssessment } from "@/components/premium/PremiumTraitAccessDeniedBar/PremiumTraitAccessDeniedBar";

type Props = {
  type: "element" | "pattern";
  slug: string;
  hidden: boolean;
  onContinue: () => void;
  name: string | undefined;
  isPremium?: boolean;
  itemLength: number;
  trackingFrequency: TrackingFrequency | null | undefined;
};

export function TraitsAssessmentIntroStepOne(props: Props) {
  const timeInMinutes = Math.ceil((props.itemLength * 5) / 60);

  return (
    <section className={styles.introStepOneMain}>
      <div className={styles.stepOneTraitDivParent}>
        <div className={styles.stepOneTraitDiv}>
          {props.type === "element" ? (
            <Element
              hideIcon={props.hidden}
              maxWidth
              slug={props.slug}
              hideName={props.hidden}
            />
          ) : (
            <Pattern
              maxWidth
              patternSlug={props.slug}
              hideName={props.hidden}
            />
          )}
        </div>
      </div>

      <div className={styles.stepOneTextDiv}>
        <h2 className={styles.stepOneTitle}>
          {`This short quiz tracks how you've evolved on ${
            props.hidden ? "a trait" : props.name
          }.`}
        </h2>
        {props.hidden && (
          <p className={styles.stepOneSubTitle}>
            {
              "Trait is hidden until you've completed the quiz to avoid biased responses."
            }
          </p>
        )}
      </div>

      {props.isPremium && (
        <div className={styles.premiumAccesBar}>
          <PremiumTraitAccessDeniedBarTraitAssessment />
        </div>
      )}

      <div className={styles.setpOneBottom}>
        <div className={styles.setpOneBottomInner}>
          <div className={styles.timeIconDiv}>
            <TimeIcon />
          </div>
          <p className={styles.setpOneBottomText}>{timeInMinutes} minutes</p>
        </div>
        {props.trackingFrequency && (
          <div className={styles.setpOneBottomInner}>
            <div className={styles.timeIconDiv}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.5743 1.04147L13.7654 5.03971C13.8418 5.29623 13.5701 5.5284 13.3201 5.39098L11.8766 4.61236L8.91626 10.3483C8.83366 10.501 8.64879 10.5561 8.49343 10.4743L5.71274 8.97011L3.28649 12.9328L0.994877 11.6932L4.51435 5.71372C4.59695 5.56103 4.78182 5.50595 4.93718 5.58776L7.71522 7.09273L9.58699 3.37337L8.14266 2.59208C7.89238 2.45669 7.93646 2.10358 8.19299 2.02716L12.1912 0.836051C12.3566 0.786772 12.524 0.87656 12.5735 1.04286L12.5743 1.04147Z"
                  fill="#FFFFF2"
                />
              </svg>
            </div>
            <p className={styles.setpOneBottomText}>
              Tracked: {trackingFrequencyMap[props.trackingFrequency]}
            </p>
          </div>
        )}
        <div className={styles.intoStepsContinueDiv}>
          <ThemedButton
            onClick={() => props.onContinue()}
            title="Continue"
            style={{ fontWeight: "450", width: "100%", padding: "14px" }}
          />
        </div>
      </div>
    </section>
  );
}

export function TraitsAssessmentIntroStepTwo(props: Props) {
  return (
    <section className={styles.stepTwoParent}>
      <h2 className={styles.stepTwoTitle}></h2>

      <div className={styles.stepTwoTextDiv}>
        <p className={styles.stepTwoText}>
          <span className={styles.stepTwoTextSpan}>Be honest</span>
          {
            "—this isn't about how you wish you felt but how you typically feel and function."
          }
        </p>
        <p className={styles.stepTwoText}>
          <span className={styles.stepTwoTextSpan}>Think broadly</span>
          {
            "—consider different areas of life (work, relationships, personal growth)."
          }
        </p>
        <p className={styles.stepTwoText}>
          <span className={styles.stepTwoTextSpan}>{"Don't overthink"}</span>
          {"—your first instinct is usually the most accurate."}
        </p>
      </div>
      <div className={styles.intoStepsContinueDiv}>
        <ThemedButton
          onClick={() => props.onContinue()}
          title="Continue"
          style={{ fontWeight: "450", width: "100%", padding: "14px" }}
        />
      </div>
    </section>
  );
}
